/*
 * Volume-savings card interactivity.
 *
 * Highlights the applicable discount tier as the shopper changes the
 * quantity in the product form. Purely presentational — the real discount
 * is applied by Shopify's automatic quantity-break discount at checkout.
 *
 * Defensive by design: if the quantity input can't be found, the card still
 * renders as a plain static list. No dependencies, no build step.
 */
(function () {
  function findQtyInput(card) {
    var scope =
      card.closest('.product__info-container') ||
      card.closest('product-info') ||
      document;
    return (
      scope.querySelector('.quantity__input') ||
      scope.querySelector('input[name="quantity"]')
    );
  }

  function update(card, tiers, qty) {
    var activeIndex = -1;
    for (var i = 0; i < tiers.length; i++) {
      var min = parseInt(tiers[i].getAttribute('data-min-qty'), 10);
      if (!isNaN(min) && qty >= min) activeIndex = i;
    }
    for (var j = 0; j < tiers.length; j++) {
      tiers[j].classList.toggle('is-active', j === activeIndex);
    }
  }

  function init(card) {
    var tiers = card.querySelectorAll('.volume-savings__tier');
    if (!tiers.length) return;

    var input = findQtyInput(card);
    if (!input) return;

    var sync = function () {
      var qty = parseInt(input.value, 10);
      update(card, tiers, isNaN(qty) ? 1 : qty);
    };

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('.volume-savings').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
